import React, { Component, Fragment } from 'react';
import { Country } from '~/Api/Country';
import { Product as GeneralProduct } from '~/Api/Product';
import { Product } from '~/Api/User/ProductGroup/CzReimbursement';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, OnSelectListener, Values } from './Row';

export interface ProductRow {
	country: Country | null;
	product: Product | null;
}

export type ProductValues = Values;

interface Props {
	products: ProductRow[];
	productValues: { [key in string]: Values };
	referenceUsualTherapeuticDailyDosePerPackage: number | null;
	detailLink(product: { id: string }): { pathname: string; search: string };
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	disableSelection: boolean;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	onSave(): void;
	checkedRows: GeneralProduct[];
	checkRow(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends Component<Props> {
	static defaultProps = {
		referenceUsualTherapeuticDailyDosePerPackage: null,
		highlightProductId: null,
		lastSelectedProductId: null,
		disableSelection: false,
	};

	render() {
		const { products } = this.props;

		return (
			<Fragment>
				<Header />
				{products.map((czReimbursementProduct) => {
					const { country, product } = czReimbursementProduct;
					return product ? this.renderRow(product) : <EmptyRow country={country} key={country?.alpha2} />;
				})}
			</Fragment>
		);
	}

	renderRow(czReimbursementProduct: Product) {
		const {
			productValues,
			referenceUsualTherapeuticDailyDosePerPackage,
			disableSelection,
			highlightProductId,
			lastSelectedProductId,
			detailLink,
			onChange,
			onSelect,
			onSave,
			checkRow,
		} = this.props;
		const { product } = czReimbursementProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				czReimbursementProduct={czReimbursementProduct}
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === product.id}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === product.id}
				referenceUsualTherapeuticDailyDosePerPackage={referenceUsualTherapeuticDailyDosePerPackage}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}
}
